<template>
  <div>
    <!-- <div class="row">
      <div class="col-xl-12">
        <div class="kt-portlet kt-portlet--mobile">
          <div class="kt-portlet__body">
            <div class="text-center text-danger">
              <i class="flaticon-warning" style="font-size: 12rem !important;"></i>
              <p
                style="font-size: 3rem !important;"
              >ขออภัย ไม่มีสิทธิ์เข้าใช้งาน กรุณาติดต่อผู้ดูแลระบบ</p>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {};
</script>



// WEBPACK FOOTER //
// App/Components/Error/Unauthorized.vue